var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trax-ui-ajax-form-hub',{attrs:{"id":"trax-account-role-edit","endpoint":_vm.endpoint,"resource-id":_vm.roleid,"props":_vm.props,"bus":_vm.bus}})
}
var staticRenderFns = []

export { render, staticRenderFns }